import { Button, styled, TextField as MuiTextField, css } from '@mui/material'

export const AddCommentButton = styled(Button)`
  width: fit-content;
`

export const TextField = styled(MuiTextField)<{ error?: boolean }>`
  width: 100%;
  ${({ theme, error }) =>
    error &&
    css`
      & > label {
        &.Mui-focused {
          color: ${theme.palette.error.main};
        }
      }
    `}
`
